<!--
@note replaces visits and likes vuejs components to reduce ajax calls

usage:
<social-stats
        ctx="ordernumber"
        uid="{ordernumber.ordernumber}"
        likeuri="{f:uri.action(action:'like',extensionName:'Mediathek',pluginName:'OrdernumberDetail',controller:'Frontend\OrdernumberDetail',arguments:{ordernumber:ordernumber,type:'like'})}"
        dislikeuri="{f:uri.action(action:'like',extensionName:'Mediathek',pluginName:'OrdernumberDetail',controller:'Frontend\OrdernumberDetail',arguments:{ordernumber:ordernumber,type:'dislike'})}"
>
</social-stats>
-->

<template>
  <div class="countsandvisits">

    <span>{{ this.visits }} Aufrufe</span>

    <div class="likes">
      <a v-on:click.prevent="like" :href="this.canlike"><i class="fa fa-thumbs-up"></i> {{ this.likes }}</a>
      <a v-on:click.prevent="dislike" :href="this.canlike"><i class="fa fa-thumbs-down"></i> {{ this.dislikes }}</a>
    </div>
  </div>
</template>

<script>

import axios from 'redaxios/dist/redaxios';

export default {
  name: 'SocialStats',
  data: () => {
    return {
      likes: 0,
      dislikes: 0,
      canlike: false,
      visits: '-',
      result: null,
    }
  },
  created() {
    axios.get('/ajax',
        {
          params: {
            get: 'social-stats',
            uid: this.$attrs.uid,
            ctx: this.$attrs.ctx
          }
        })
        .then(response => {
          if (response.data) {
            this.visits = parseInt(response.data.visits);
            this.likes = parseInt(response.data.likes.likes);
            this.dislikes = parseInt(response.data.likes.dislikes);
            this.canlike = response.data.likes.canlike;
          }
        });
  },
  methods: {
      async like() {
        if (this.canlike) {

          // tracking event video thumbs up
          SK.tracking.Event(
              'VideoThumbsUp',
              SK.playlist.tracking.getCurrentTrackingData()
          );

          this.canlike = false;
          await axios.get(this.$attrs.likeuri)
              .then(response => {
                if (response.data.like.status === 'ok') {
                  this.likes += 1;
                }
              });
        }
      },
      async dislike() {
        if (this.canlike) {

          // tracking event video thumbs down
          SK.tracking.Event(
              'VideoThumbsDown',
              SK.playlist.tracking.getCurrentTrackingData()
          );

          this.canlike = false;
          await axios.get(this.$attrs.dislikeuri)
              .then(response => {
                if (response.data.like.status === 'ok') {
                  this.dislikes += 1;
                }
              });
        }
      }
  }
}
</script>

<style lang="scss">
</style>